import loader, { raw } from './loader';

module.exports = loader;
module.exports.raw = raw;
